import itemsService from '../../services/items'
import categoriesService from '../../services/categories'

const state = {
  itemsFromRepository: [],
  categoriesFromRepository: [],
  itemsSearch: []
}

// getters 
const getters = {
  getItemIndex: (state) => (itemId) => {
    return state.itemsFromRepository
                .findIndex(item => item.itemId === itemId);
  },
  getItemById: (state) => (itemId) => {
    return state.itemsFromRepository
                .find(item => item.itemId === itemId);
  },
  getItemByCategory: (state) => (categoryId) => {
    return state.itemsFromRepository
                .find(item => item.categoryId === categoryId);
  }
}

// actions
const actions = {
  async getItemsFromRepositoryAction(context) {
    if ( state.itemsFromRepository.length === 0) {
      await itemsService.getItemsByRestaurant()
                      .then( data => { context.commit('setItemsFromRepositoryState', data)});
    }
  },
  async getCategoriesFromRepositoryAction(context) {
    if (state.categoriesFromRepository.length === 0) {
      await categoriesService.getCategoriesByRestaurant()
                           .then( data => { context.commit('setCategoriesFromRepositoryState', data);
                                            console.log( 'getCategoriesFromRepositoryAction: ', data.length )});
    }
  }
}

// mutations
const mutations = {
  setItemsFromRepositoryState(state, items) {
    items.forEach(function(i) {
      i.isChecked = true;
    });
    state.itemsFromRepository = items;
  },
  setCategoriesFromRepositoryState(state, categories) {
    state.categoriesFromRepository = categories;
  },
  addItemToSelectedItemsState(state, item) {
    let index = state.itemsFromRepository
                     .findIndex(i => i.itemId === item.itemId);
    if (index > -1) {
      state.items[index] = item;
    }
    state.items.push(item);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}